// extracted by mini-css-extract-plugin
module.exports = {"root":"milk-dairy-disposal-page_root__7Gsb7"};